'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";
import MunicipalitySelectController from "./controller/municipalitySelect";
import MunicipalitiesController from "./controller/municipalities";
import MunicipalityModalCreateController from "./controller/municipalityModalCreate";
import MunicipalityFilterController from "./controller/municipalityFilter";
import MunicipalityTableDirective from "./directive/municipalityTable";
import MunicipalityService from "./service/municipality";

export default angular.module('investmentProject.municipality', [])
    .controller('MunicipalitySelectController', MunicipalitySelectController)
    .controller('MunicipalitiesController', MunicipalitiesController)
    .controller('MunicipalityModalCreateController', MunicipalityModalCreateController)
    .controller('MunicipalityFilterController', MunicipalityFilterController)
    .directive('municipalityTable', MunicipalityTableDirective)
    .factory('MunicipalityService', MunicipalityService)
    .name;